import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import {NgbDateStruct, NgbCalendar, NgbDate,  NgbDatepickerConfig, NgbDatepickerI18n, NgbDateParserFormatter, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { DateformatService } from '../../../util/dateformat.service';
import { NgbActiveModal, NgbNavContent } from '@ng-bootstrap/ng-bootstrap';
import { Activity } from '../../model/activity.model';
import { RequirementService } from 'src/app/services/requirement.service';
import { Subject, throwError } from 'rxjs';
import {debounceTime} from 'rxjs/operators';
import { Alert } from '../../model/alert.model';
import { I18n, CustomDatepickerI18n } from 'src/app/util/ngbd-datepicker-i18n/ngbd-datepicker-i18n.component';
import moment from 'moment';
import { isNumber } from '@app/trackvision/util/util';
import { ReminderComponent } from '../../components/calendar-view/reminder/reminder.component';
@Component({
    selector: 'app-edit-activity',
    templateUrl: './edit-activity.component.html',
    styleUrls: ['./edit-activity.component.scss'],
    providers: [
        I18n,
        { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n },
        { provide: NgbDateParserFormatter, useClass: DateformatService }
    ],
    standalone: false
})
export class EditActivityComponent implements OnInit {
	@Output() insertEditActv = new EventEmitter<boolean>();
	@Input() reqId: number;
	@Input() idActivity: number;

	newActivity: Activity = new Activity();
	newAlert: Alert = new Alert();
	model1: NgbDateStruct = null;
	model2: NgbDateStruct = null;
	timeActivity = null;
	timeAlert = null;
	meridian = true;
	meridian1 = true;
	mindate = undefined;
	maxdate = {};
	reminderActv = null;
	showTableAlert: boolean = false;
	sentData: boolean = false;
	loading: boolean = false;
	listEmailsColab: Array<string> = [];
	alerts: Array<any> = [];
	errorMessageNewAlert: string = '';
	successMessageNewAlert: string = '';
	errorMessage: string = '';
	successMessage: string = '';
	private _success = new Subject<string>();
	private _error = new Subject<string>();
	private _successNewAlert = new Subject<string>();
	private _errorNewAlert = new Subject<string>();
	//  var message delete alert
	successMessageDeleteAlert: string = '';
	private _successDeleteAlert = new Subject<string>();
	// variables about reminder 
	showReminder : boolean = false; 
	activeReminder: boolean = false;
	ordinal_name: string = '';
	ordinal_day_name: string = '';
	ordinal_day_names: string = '';
	text_reminder: string = ''; 
	last_day:string = '';
	rest_of_days: string = ''; 
	reminderObj: any;
	// variables to reminder component modal
	date_start: string = '';
	date_end: string = ''; 
	ordinal_day: number = 0;
	ordinal_month: number = 0;
	type_reminder: number = 0;
	weekOfDays: Array<number> = [];
	daysOfWeek: any;
	idRem: number;
	actvId: number;
  constructor(
		private modalService: NgbModal,
		public activeModal: NgbActiveModal,
		public _requirements: RequirementService,
	) { }

  ngOnInit() {
		// loading modules
		this.loadAlerts();
		const current = new Date();
		this.mindate = {
			year: current.getFullYear(),
			month: current.getMonth() + 1,
			day: current.getDate()
		};
		// messages submits
		this.messageSubmitForm();
		this.messageNewAlert();
		this.messageDeleteAlert();
	}
	closeModal() {
		this.activeModal.close('Modal Closed');
	}
	//Submit Form
	submitForm() {
			// SUBMIT if all my fields of activyt are ok
		const validatonActv = this.validationActvDateAlert();
		if (validatonActv) {
			// loading values to newActivity
			const subject = this.newActivity.subject.trim();
			const content = this.newActivity.content.trim();
			const activityDate = this.model1.year + '-' + this.model1.month + '-' + this.model1.day;
			const activityTime = this.timeActivity.hour + ':' + this.timeActivity.minute + ':' + this.timeActivity.second;
			this.newActivity.requirementid = this.reqId;
			this.newActivity.subject = subject;
			this.newActivity.content = content;
			this.newActivity.activity_date = activityDate;
			this.newActivity.activity_time = activityTime;
			// validation if another activity exists
			const data = {
				id: this.idActivity,
				activity : this.newActivity
			};
			this._requirements.validationEditActvAlert(data).subscribe(resp => {
				let result = resp['result'];
				if (result) {
					this._error.next('Ya existe una actividad agendada a la misma hora y fecha.');
				} else {
					this.loading = true;	
					const data = {
						id: this.idActivity,
						activity : this.newActivity,
						alerts: this.alerts,
						collaborators : this.listEmailsColab,
						activeRem: this.activeReminder
					};
					this._requirements.editActivity(data).subscribe( resp => {
							if (resp['error']) {
								this.loading = false;
								this._error.next( 'Error: No se pudo crear lo solicitado, inténtelo de nuevo!!!');
							} else {

								this.loading = false;
								this._success.next('Se editó la actividad.');
								setTimeout(() => this.activeModal.dismiss(), 2000);
								setTimeout(() => this.insertEditActv.emit(true), 2000);
							}
						});
						this.newAlert = new Alert();
						//this.sentData = true;
						//form.reset();
				}
			});
		}
	}
	changeMaxDate(value) {

		this.maxdate = value;
	}
	/* ADD COLLABORATORS */
	retrieveCollab(event){
		this.listEmailsColab = event;
	}
	// Load modules
	loadAlerts() {
		// Getting history activities alerts
		this._requirements.geActivityById(this.reqId, this.idActivity).subscribe(resp => {
			if (resp['result']) {
				let actvAlertReminder = resp['result'];
				this.findItem(actvAlertReminder);
				// Reminder
				let reminderActv = actvAlertReminder.reminder;
				this.showReminderFront(reminderActv);
			}
		});
	}
	findItem(activity) {
		// find the activity and the activity's alert
		//const activity = alertActv.find( actv => actv.activity.id === this.idActivity);

		// Insert data into the selected activity
		this.newActivity.subject = activity.activity.subject;
		this.newActivity.content = activity.activity.content;
		this.model1 = {
			year: Number(activity.activity.activity_date.substring(0, 4)),
			month: Number(activity.activity.activity_date.substring(5, 7)),
			day: Number(activity.activity.activity_date.substring(8, 10)),
		};
		this.timeActivity = {
			hour: Number(activity.activity.activity_time.substring(0, 2)),
			minute: Number(activity.activity.activity_time.substring(3, 5)),
			second: Number(activity.activity.activity_time.substring(6, 8))
		};
		// Insert Alert
		this.maxdate = this.model1;
		if ( activity.alert.length > 0) {
			this.showTableAlert = true;
			this.alerts = activity.alert;
		}
		
		//this.dateActv = activity.activity.activity_date.substring(0,10).split('-').reverse().toString().replace(',','/').replace(',','/');
		/* // insert MaxDate
		// Alert
		const alert = activity.alert.find( alt => alt.id === this.idAlert);
		this.alertName = alert.name;
		 */
	}
	showReminderFront(reminderActv){

		if(reminderActv){
			this.showReminder = true;
			// retrieveing data to show to reminder component 
			this.date_start = reminderActv.date_start.substring(0, 10).split('-').reverse().toString().replace(',', '/').replace(',', '/');
			this.date_end = reminderActv.date_end.substring(0, 10).split('-').reverse().toString().replace(',', '/').replace(',', '/');
			this.ordinal_day = reminderActv.ordinal_day;
			this.ordinal_month = reminderActv.ordinal_month;
			this.type_reminder = reminderActv.type_reminder;
			this.idRem = reminderActv.id;
			this.actvId = reminderActv.activityid;
			let weekOfDays = reminderActv.weekDays;
			// this is checkbox
			this.activeReminder = reminderActv.active;
			// this is for the title 
			// what type of reminder is ?
			let typeReminder = reminderActv.type_reminder;
			let ordinalmonthNumb = reminderActv.ordinal_month;
			let ordinal_day = reminderActv.ordinal_day;

			this.createTitleReminder(typeReminder, ordinalmonthNumb, ordinal_day, weekOfDays);
		}
	}
	addAlert() {
		const resultAlert = this.validationNewAlert();
		if ( resultAlert ) {
				this.showTableAlert = true;
				this.addingNewAlert();
				// insert data newAlert
				this.alerts.push(this.newAlert);
				// clean variables of new Alert
				this.newAlert = new Alert();
				this.newAlert.before_activity_date = '';
				this.newAlert.before_activity_time = '';
				this.model2 = null;
				this.timeAlert = null;
			}
	}
	deleteAlert(alertName: string) {
		// delete an item of newAlert
		this.alerts.splice(this.alerts.findIndex(v => v.name === alertName), 1);
		if (this.alerts.length < 1) {
			this._successDeleteAlert.next('Se elimino correctamente.');
			setTimeout(() => this.showTableAlert = false, 2000);
		}
		this._successDeleteAlert.next('Se elimino correctamente.');
	}
	addingNewAlert() {
		// second, add alert count depending on subject
		// first find the correct subject if it exits
		let lastAlert = this.alerts[this.alerts.length - 1];

		let alertDate = this.model2.year + '-' + this.model2.month + '-' + this.model2.day;
		let alertTime = this.timeAlert.hour + ':' + this.timeAlert.minute + ':' + this.timeAlert.second;
		if (lastAlert == undefined) {
			this.newAlert.name = 'Alerta ' + 1;
		} else {
			let number = Number(lastAlert.name.substring(7, 8));
			number++;
			this.newAlert.name = 'Alerta ' + number;
		}
		this.newAlert.before_activity_date = alertDate;
		this.newAlert.before_activity_time = alertTime;
		this.newAlert.sent = false;
	}
	// validation fields of activity Alert
	validationActvDateAlert(): boolean {
		let subject = this.newActivity.subject;

		if ((subject === undefined || subject.trim() === '') && this.model1 == null && this.timeActivity == null) {
					this._error.next('Error: Falta llenar todos los campos de la actividad.');
					return false;
			}  else if ((subject === undefined || subject.trim() === '') && this.model1 == null && this.timeActivity !== null) {
					this._error.next('Error: Falta los campos Asunto y Fecha de la actividad.');
					return false;
			} else if ((subject === undefined || subject.trim() === '') && this.model1 !== null && this.timeActivity == null) {
					this._error.next('Error: Falta los campos Asunto y Hora de la actividad.');
					return false;
			} else if ((subject === undefined || subject.trim() === '') && this.model1 !== null && this.timeActivity !== null) {
					this._error.next('Error: Falta el  Asunto de la actividad.');
					return false;
			} else if (subject !== undefined && this.model1 == null && this.timeActivity == null) {
				this._error.next('Error: Falta los campos Fecha y Hora de la actividad.');
				return false;
			} else if (subject !== undefined && this.model1 == null && this.timeActivity !== null) {
				this._error.next('Error: Falta la Fecha de la actividad.');
				return false;
			} else if (subject !== undefined && this.model1 !== null && this.timeActivity == null) {
				this._error.next('Error: Falta la Hora de la actividad.');
				return false;
			} else if (subject !== undefined && this.model1 !== null && this.timeActivity !== null) {
				return true;
			}
	}
	validationNewAlert(): boolean {
		// check it out if alert exists into the array
		// first, retrive the object of activity if you want to validate
		let foundAlert = false;
		if (this.model2 == null && this.timeAlert == null) {
			this._errorNewAlert.next('Error: Falta seleccionar una Fecha y Hora.');
			return false;
		} else if ( this.model2 == null && this.timeAlert !== null){
			this._errorNewAlert.next('Error: Falta llenar el campo Fecha.');
			return false;
		} else if ( this.model2 !== null && this.timeAlert == null) {
			this._errorNewAlert.next('Error: Falta llenar el campo Hora.');
			return false;
		} else if ( this.model2 !== null && this.timeAlert !== null) {
			const alertDate = this.model2.year + '-' + this.model2.month + '-' + this.model2.day;
			const alertTime = this.timeAlert.hour + ':' + this.timeAlert.minute + ':' + this.timeAlert.second;
			const activityDate = this.model1.year + '-' + this.model1.month + '-' + this.model1.day;
			//const activityTime = this.timeActivity.hour + ':' + this.timeActivity.minute + ':' + this.timeActivity.second;
			if ( alertDate === activityDate &&  this.timeAlert.hour >= this.timeActivity.hour && this.timeAlert.minute >= this.timeActivity.minute ) {
				this._errorNewAlert.next('Error: Fecha y Hora, no permitida.');
				return false;
			}
			// this is for validation if It exists the same date and hour alert into the array alert
			if (this.alerts.length > 0 ) {
				for ( const alert in this.alerts) {
					if ( this.alerts[alert].before_activity_date.substring(0, 10) === alertDate &&
						this.alerts[alert].before_activity_time === alertTime) {
						foundAlert = true;
						break;
					}
				}
			} else {
				foundAlert = false;
			}
			if (foundAlert) {
				this._errorNewAlert.next('Error: Ya existe una alerta con la misma Fecha y Hora!!!');
				return false;
			} else {
				this._successNewAlert.next('Se registró una alerta correctamente!!!');
				return true;
			}
		}
	}
	messageSubmitForm() {
		this._success.subscribe(message => this.successMessage = message);
		this._success.pipe (
			debounceTime(2000)
		).subscribe(() => this.successMessage = '');
		this._error.subscribe(message => this.errorMessage = message);
		this._error.pipe (
				debounceTime(2000)
		).subscribe(() => this.errorMessage = '');
	}
	// message alert
	messageNewAlert() {
		this._successNewAlert.subscribe(message => this.successMessageNewAlert = message);
		this._successNewAlert.pipe (
			debounceTime(2000)
		).subscribe(() => this.successMessageNewAlert = '');
		this._errorNewAlert.subscribe(message => this.errorMessageNewAlert = message);
		this._errorNewAlert.pipe (
				debounceTime(2000)
		).subscribe(() => this.errorMessageNewAlert = '');
	}
	messageDeleteAlert() {
		this._successDeleteAlert.subscribe(message => this.successMessageDeleteAlert = message);
		this._successDeleteAlert.pipe (
				debounceTime(2000)
		).subscribe(() => this.successMessageDeleteAlert = '');
	}
	// Reminder information 
	typeReminder(idType: number){
		switch (idType) {
			case 2 :
				this.text_reminder = 'Semanalmente (' + this.rest_of_days +  this.last_day + ')';
				break;
			case 3 :
				this.text_reminder = 'Mensualmente (' + this.ordinal_name +') (' + this.ordinal_day_name + ')'; 
				break;
			default:
				break;
		}
	}
	ordinalMonth(numb: number) {
		// 'primer', 'segundo', 'tercero', 'cuarto', 'último
		switch (numb) {
			case 1 :
				this.ordinal_name = 'Primer';
				break;
			case 2 :
				this.ordinal_name = 'Segundo';
				break;
			case 3 :
				this.ordinal_name = 'Tercer';
				break;
			case 4 :
				this.ordinal_name = 'Cuarto';
				break;
			case 5 :
				this.ordinal_name = 'Último';
				break;
			default:
				break;
		}
	}
	ordinalMonthlyDays(day: number) {
		// 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado', 'domingo'
		switch (day) {
			case 1 :
				this.ordinal_day_name = 'Lunes';
				break;
			case 2 :
				this.ordinal_day_name = 'Martes';
				break;
			case 3 :
				this.ordinal_day_name = 'Miércoles';
				break;
			case 4 :
				this.ordinal_day_name = 'Jueves';
				break;
			case 5 :
				this.ordinal_day_name = 'Viernes';
				break;
			case 6 :
				this.ordinal_day_name = 'Sábado';
				break;
			case 0 :
				this.ordinal_day_name = 'Domingo';
				break;
			default:
				break;
		}
	}
	ordinalWeeklyDays(day: number) {
		// 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado', 'domingo'
		switch (day) {
			case 1 :
				this.ordinal_day_names = 'Lunes';
				break;
			case 2 :
				this.ordinal_day_names = 'Martes';
				break;
			case 3 :
				this.ordinal_day_names = 'Miércoles';
				break;
			case 4 :
				this.ordinal_day_names = 'Jueves';
				break;
			case 5 :
				this.ordinal_day_names = 'Viernes';
				break;
			case 6 :
				this.ordinal_day_names = 'Sábados';
				break;
			case 0 :
				this.ordinal_day_names = 'Domingos';
				break;
			default:
				break;
		}
	}
	getWeekDays(days: Array<number>){
		let days_name = days.map( (numbDay)=> {
			this.ordinalWeeklyDays(numbDay);
			return this.ordinal_day_names;
		}); 
		// get last day 
		this.last_day = ' y ' + days_name.pop();
		this.rest_of_days = 'Todos los ' + days_name.toString();
	}
	getWeekDay(days: Array<number>){
		let day = days.pop();
		this.ordinalWeeklyDays(day);
		this.rest_of_days = this.ordinal_day_names;
	}
	// calling modal reminder 
	modifyReminder() {
		/* const activityTime = this.timeActivity.hour + ':' + this.timeActivity.minute + ':' + this.timeActivity.second;
		const subject = this.newActivity.subject; */
		const modalRef = this.modalService.open(ReminderComponent, { scrollable: true, size: 'sm', backdrop: 'static',
			keyboard: false });
			modalRef.componentInstance.date_start = this.date_start;
			modalRef.componentInstance.date_end = this.date_end;
			modalRef.componentInstance.ordinal_day = this.ordinal_day;
			modalRef.componentInstance.ordinal_month = this.ordinal_month;
			modalRef.componentInstance.type_reminder = this.type_reminder;
			modalRef.componentInstance.days_of_week = this.daysOfWeek;
			modalRef.componentInstance.sendReminder.subscribe(sendReminder => {
				if (sendReminder){
					let reminderObj = {
						date_start: sendReminder.date_start,
						date_end: sendReminder.date_end,
						type_reminder: sendReminder.type_reminder,
						days_of_week: sendReminder.days_of_week,
						ordinal_month: sendReminder.ordinal_month,
						ordinal_day: sendReminder.ordinal_day
					}
					// create services to update reminder 
					this._requirements.editReminder(this.idRem, this.reqId, this.actvId, reminderObj).subscribe((resp)=> {
	
						if (resp['result']){
							this.loadAlerts();
							this.insertEditActv.emit(true);
						}
					});
				}
			});
	}
	// create the title reminder, for instance: Semanalmente(Sabado)
	createTitleReminder(typeRem: number, ordMonthNumb: number, ordDay:number, weekDays: Array<number>){
			//clean variables 
			this.ordinal_name  = '';
			this.ordinal_day_name = '';
			this.ordinal_day_names = '';
			this.rest_of_days = '';
			this.last_day = '';
			// monthly
			if (isNumber(ordMonthNumb)){
				this.ordinalMonth(ordMonthNumb);
			}
			if (isNumber(ordDay)){
				this.ordinalMonthlyDays(ordDay);
			}
			// weekly
			if(weekDays != null){
				if (weekDays.length > 1 ){
					this.daysOfWeek = weekDays;
					this.getWeekDays(weekDays);
				}
				if (weekDays.length === 1){
					this.daysOfWeek = weekDays[0];
					this.getWeekDay(weekDays);
				}
			}
			this.typeReminder(typeRem);
	}

}
